import conditions from './conditions';

export default {
  conditions
};
